module.exports = __WEBPACK_EXTERNAL_MODULE_59__;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 59
// module chunks = 0